import styled from 'styled-components';

export const FormAutoSuggestDropdownCheckboxStyled = styled.div`
  .box_input_item {
    width: 100%;
  }
`;

export default FormAutoSuggestDropdownCheckboxStyled;
